import LoaderSvg from '../../../../../public/assets/icons/loader.svg';
import { LoaderWrapper } from './styles';

type Props = {
	size?: number;
	plane?: boolean;
};

export const Loader = ({ size = 60, plane }: Props) => (
	<LoaderWrapper className="loader" size={size} plane={plane}>
		<LoaderSvg />
	</LoaderWrapper>
);
